// Page subtitle and document title management

"use strict";

import { onUnmounted } from "vue";

const PLATFORM_NAME = import.meta.env.VITE__PLATFORM_NAME;

/**
 * Sets the browser tab title using the page subtitle and platform name.
 * @param title Page subtitle shown before the platform name
 */
export function setPageSubTitle(title: string): void {
    document.title = title + " | " + PLATFORM_NAME;
}

/**
 * Resets the browser tab title to the platform name only.
 */
export function resetPageTitle(): void {
    document.title = PLATFORM_NAME;
}

/**
 * Composable for page subtitles with automatic title reset on unmount.
 * @returns `setSubTitle` to update the document title for the current page
 */
export function usePageTitle() {
    let hasSubTitle = false;

    /**
     * Sets the page subtitle in the document title.
     * @param title Page subtitle shown before the platform name
     */
    const setSubTitle = (title: string) => {
        hasSubTitle = true;
        setPageSubTitle(title);
    };

    onUnmounted(() => {
        if (hasSubTitle) {
            resetPageTitle();
        }
    });

    return { setSubTitle };
}
